import getters from './getters.js'
import mutations from './mutations.js'
import actions from './actions.js'

export default {
  state: {
    hotelId: 0, // 门店ID
    hotelInfo: {}, // 门店信息
    hotelList: [], // 门店列表
    allowHotelCount: 50, // 允许创建的门店的最大条数,
    isBindWechart: false,// 是否绑定微信公众号
    cityCn: '',
  },
  getters,
  mutations,
  actions
}
